import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * OpportunityType service class containing all methods to retrieve opportunityType
 */
class OpportunityTypeService {
  static getOpportunityTypes(limit = 10, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}?pageSize=${limit}&page=${page}`)
  }

  static getOpportunityType(slug) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}/${slug}`)
  }

  static updateOpportunityType(opportunityType) {
    if (typeof opportunityType._id === 'undefined') {
      return this.addOpportunityType(opportunityType)
    }

    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}/${opportunityType['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        opportunityType
      })
    })
  }

  static addOpportunityType(opportunityType) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}`, {
      method: 'POST',
      body: JSON.stringify({
        opportunityType
      })
    })
  }

  static deleteOpportunityType(slug) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}/${slug}`, {
      method: 'DELETE'
    })
  }
}

export default OpportunityTypeService
